import { IconsDirective } from '@awork/_shared/directives/icons/icons.directive'
import { getAvatarInitials, getAvatarInitialsColor } from '@awork/_shared/functions/avatar-initials'
import { Component, computed, input } from '@angular/core'

@Component({
  selector: 'aw-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.scss'],
  imports: [IconsDirective]
})
export class AvatarComponent {
  readonly image = input<string>()
  readonly icon = input<string>()
  readonly text = input<string>()
  readonly subLabel = input<string>()
  readonly size = input<string>('m')
  readonly initials = input<string>()
  readonly showLabel = input<boolean>(true)
  readonly showInitials = input<boolean>(true)

  protected readonly letters = computed(() => this.initials() || getAvatarInitials(this.text() || ''))
  protected readonly color = computed(() => getAvatarInitialsColor(this.letters()))
}
